import { useEffect, useState } from 'react';

import userAPI from '../../services/api/user';
import useStore from '../../store';

export const useUser = (): boolean => {
  const [isLoading, setIsLoading] = useState(true);
  const getUserById = useStore(state => state.getUserById);

  useEffect(() => {
    const getUser = async () => {
      try {
        const { id } = await userAPI.getUserIdByToken();
        await getUserById(id);
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    getUser();
  }, []);

  return isLoading;
};
